<div class="review-card">
  <img class="event-image" [src]="event?.image?.image?.url" />
  <div>
    <p class="details-title mb-0 details-container">
      {{ "General Details" | translate }}
    </p>
    <div class="details-container">
      <div class="row mt-4">
        <div class="col-lg-7 col-md-12 col-12">
          <p class="general-event-detail">
            {{ "Event name" | translate }} :
            <span class="custom-event-detail">
              {{ helpers.getElementTranslatedName(event) }}</span
            >
          </p>
        </div>
        <div class="col">
          <p class="general-event-detail">
            {{ "Quantity" | translate }} :
            <span class="custom-event-detail">
              {{ ticketService.getTotalQuantity() }}</span
            >
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-7 col-md-12 col-12">
          <p class="general-event-detail">
            {{ "your name" | translate }} :
            <span class="custom-event-detail">
              {{ ticketService.getSalesInfo().firstName }}
              {{ ticketService.getSalesInfo().lastName }}
            </span>
          </p>
        </div>
        <div class="col">
          <p class="general-event-detail">
            {{ "Mobile number" | translate }} :
            <span
              [style.text-align]="translate.currentLang == 'ar' ? 'end' : ''"
              class="custom-event-detail"
              style="unicode-bidi: plaintext"
            >
              {{ ticketService.getSalesInfo().mobile.number }}
            </span>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <p class="general-event-detail">
            {{ "email" | translate }} :
            <span class="custom-event-detail">
              {{ ticketService.getSalesInfo().email }}
            </span>
          </p>
        </div>
      </div>
    </div>

    <hr class="dashed" />
    <div class="details-container" style="padding-bottom: 32px">
      <div *ngFor="let item of invoice?.items">
        <app-cart-item [review]="true" [item]="item"></app-cart-item>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="event?.policies?.length > 0"
  class="bk-white mt-4"
  (click)="openPlolicies = !openPlolicies"
>
  <div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="conditions-title">
        {{ "Terms and Conditions" | translate }}
      </div>
      <i *ngIf="!openPlolicies" class="fa fa-chevron-down"></i>
      <i *ngIf="openPlolicies" class="fa fa-chevron-up"></i>
    </div>
    <div *ngIf="openPlolicies">
      <div
        *ngFor="let policy of event?.policies"
        [innerHTML]="policy?.nameAr | safeHTML"
      ></div>
    </div>
  </div>
</div>
